import { createSelector } from 'reselect'
import API from '../../../../../utils/http/api'
import fixtures from '../../../../../fixtures'

// @TODO Add ability to make a note on a saved job

// Action Types
const REQUEST = 'steppingblocks/savedCareerSearches/REQUEST'
const SUCCESS = 'steppingblocks/savedCareerSearches/SUCCESS'
const FAILURE = 'steppingblocks/savedCareerSearches/FAILURE'
const SAVE_SUCCESS = 'steppingblocks/savedCareerSearches/SAVE_SUCCESS'
const DELETE_SUCCESS = 'steppingblocks/savedCareerSearches/DELETE_SUCCESS'

// Reducer
const initialState = {
  error: null,
  requestStarted: false,
  requestEnded: false,
  results: [],
  pagination: fixtures.pagination,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results,
        pagination: payload.pagination,
      }
    case SAVE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.result.concat(_state.results),
      }
    case DELETE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: _state.results.filter(item => item._id !== payload.id),
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    default:
      return _state
  }
}

// Action Performers
export const performRetrieveSavedCareerSearches = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.get(`/resumes/career/saved/${params.user_id}`, {})
    dispatch({
      type: SUCCESS,
      payload: {
        results: data.results,
        pagination: data.pagination,
      },
    })
    return data
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
    return error
  }
}

export const performSaveCareerSearch = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.post('/resumes/career/save', params)
    dispatch({
      type: SAVE_SUCCESS,
      payload: {
        result: [data.result],
      }
    })
    return data
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message }
    })
    throw new Error(error)
  }
}

export const performDeleteSavedCareerSearch = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    await API.del(`/resumes/career/save/${params.id}`)
    dispatch({
      type: DELETE_SUCCESS,
      payload: {
        id: params.id
      }
    })
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message }
    })
    throw new Error(error)
  }
}

// Selectors
const savedCareerSearches = state => state.savedCareerSearches

export const getSavedCareerSearches = createSelector(savedCareerSearches, data => data.results)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/savedCareerSearchesDuck.js